
const chameleon = require('@chamaeleonidae/chmln');
import config from '../../config';

let isInitialized = false;
const isBrowser = typeof window !== "undefined";

const { CHAMELEON_API_KEY } = config;


export const initChameleon = () => {
  if (!isBrowser) return;   // prevent Vitest crash
  if (isInitialized) return;
  if (!CHAMELEON_API_KEY) return;

  try {
    chameleon.init(CHAMELEON_API_KEY);
    isInitialized = true;
  } catch {
    isInitialized = false;
  }

};

export const identifyChameleonUser = (user) => {

  if (!isBrowser) return;
  if (!window.chmln) return;
  if (!user || !user.username) return;

  window.chmln.identify(user.username);
};

export const trackChameleonEvent = (event) => {
  if (!isBrowser) return;
  if (!window.chmln) return;

  window.chmln.track(event);
};

export const clearChameleon = () => {
  if (!isBrowser) return;
  if (!window.chmln) return;

  window.chmln.clear();
};
